import ExecMonitor from '../pages/ExecMonitor'

/**
 *
 */
function getPropsFromQueryParams (route) {
  let props = { inputFilters: {} }
  let filterPrefix = 'filter_'
  for (var prop in route.query) {
    if( route.query.hasOwnProperty( prop ) ) {
      // Is prop a filter?
      if (prop.indexOf(filterPrefix) === 0) {
        let filterName = prop.substring(filterPrefix.length)

        if (route.query[prop]) {
          props.inputFilters[filterName] = String(route.query[prop]).split(',')
        }
      } else {
        // Prop is not a filter
        props[prop] = route.query[prop]
      }
    }
  }

  // console.log("Router, 'getPropsFromQueryParams', props");
  // console.log(props);

  return props
}

const routes = [
  {
    path: '',
    component: ExecMonitor,
    props: getPropsFromQueryParams
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/apps/bpm/monitor/router/routes.js